<script setup>
import { computed } from "vue"

/// STORE GETTERS
import { useStore } from "../../utils"
const store = useStore()

const getRegionOptions = computed(() => {
  return store.getters["locale/GET_REGION_OPTIONS"].map(
    ({ countryCode, name }) => {
      return {
        countryCode,
        name,
        label: countryCode
      }
    }
  )
})
</script>

<template>
  <div class="locale-selector noselect flex--col-center-center">
    <button class="locale-selector__close-cross" @click="closeModal">
      <Cross class="locale-selector__close-cross-svg" />
    </button>
    <div class="locale-selector__background"></div>
    <div class="locale-selector__text-wrapper text--clr-black">
      <div
        class="locale-selector__title text-heading-1 text--font-antique-olive text--uppercase text--center"
      >
        {{ UI_ELEMENT("locale_selector_modal_title") }}
      </div>
      <div class="locale-selector__title text-body ">
        {{ UI_ELEMENT("locale_selector_modal_subtitle") }}
      </div>
      <div class="locale-selector__locales-section">
        <div
          class="locale-selector__options-list text-body text--left text--w-bold pt-40 pb-12"
        >
          <div
            class="mb-8 locale-selector__option"
            :key="region.label"
            v-for="region in getRegionOptions"
            @click="evt => changeLocale(region.countryCode)"
          >
            <span
              class="locale-selector__option-text"
              :class="{
                'locale-selector__option-text--active':
                  region.countryCode === localeConfig.countryCode
              }"
              >{{ region.name }}</span
            >
            <div
              class="locale-selector__option-highlight"
              v-if="region.countryCode === localeConfig.countryCode"
            >
              <Globe class="locale-selector__globe-icon"></Globe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalComponentMixin from "@/plugins/ModalContainer/ModalComponentMixin"

// import RichText from "@/components/RichText"
import Cross from "@/assets/cross.svg"
import Globe from "@/assets/globe.svg"
import { mapActions } from "vuex"
import { mapState } from "vuex/dist/vuex.common.js"

export default {
  name: "LocaleSelectorModal",
  // specific config for the enter/leave animations for this modal
  transitions: {
    xs: ["center-slide-up", 300]
  },

  mixins: [ModalComponentMixin],

  components: {
    // RichText,
    Cross,
    Globe
  },

  computed: {
    ...mapState("locale", ["localeConfig"])
  },

  methods: {
    ...mapActions("locale", ["CHANGE_LOCALE"]),

    closeModal() {
      // All modals need to call this.emitClose() from their own close method
      this.emitClose()
    },

    changeLocale(countryCode) {
      Bleach.debug.log("changeLocale", countryCode)
      this.CHANGE_LOCALE({
        countryCode
      })
    }
  }
}
</script>
<style lang="scss">
$padding-top-default: 35px;
$padding-top-lg: 50px;

$stroke-width: 1px;

.locale-selector {
  text-align: center;
  padding: $padding-top-default 30px 30px;
  pointer-events: all;

  @include media-breakpoint-up(lg) {
    padding: $padding-top-lg 30px 40px;
  }

  &__close-cross {
    position: absolute;
    z-index: 2;
    background-color: transparent;
    top: 15px;
    right: 20px;
    width: 26px;
    height: 26px;
    padding: 3px;
    cursor: pointer;
    border: none;
    outline: none;
    border-radius: 0;
  }

  &__close-cross-svg {
    path {
      stroke: getcolour(bleach_black);
      vector-effect: non-scaling-stroke;
      stroke-width: 1.5px;
    }
  }

  &__background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: getcolour(bleach_grey_90);
    background: linear-gradient(
      0deg,
      rgba(getcolour(bleach_grey_90), 0.8) 0%,
      rgba(getcolour(bleach_grey_90), 1) 100%
    );
    // filter: drop-shadow(0 2px 3px rgba(getcolour(bleach_black), 0.5));
  }

  &__text-wrapper {
    position: relative;
    margin: 0 auto;
    max-width: 800px;
  }

  &__title {
    margin: 0 auto;
    max-width: 200px;

    @include media-breakpoint-up(md) {
      max-width: 500px;
    }
  }

  &__copy {
    margin: 10px auto 20px;

    @include media-breakpoint-up(md) {
      margin: 15px auto 30px;
    }
  }

  &__options-list {
    column-count: 3;
    column-gap: 40px;
    column-rule: 1px solid getcolour(bleach_grey_80);
    width: fit-content;
    margin: 0 auto;
  }

  &__option {
    position: relative;
    display: block;
    cursor: pointer;
    width: fit-content;

    &:hover {
      text-decoration: underline;
      text-underline-offset: 1px;
      text-decoration-thickness: 4px;
      text-decoration-skip-ink: none;
      text-decoration-color: rgba(getcolour(bleach_white), 0.8);
    }
  }

  &__option-text {
    &--active {
      // color: getcolour(bleach_pink_dark);
    }
  }

  &__option-highlight {
    position: absolute;
    margin-left: 0.25em;
    width: 1em;
    left: 100%;
    top: 0.1em;
  }

  &__globe-icon {
    width: 100%;
    stroke: getcolour(bleach_pink_dark);

    path,
    circle,
    ellipse {
      stroke: inherit;
      fill: none;
      stroke-width: $stroke-width;
      vector-effect: non-scaling-stroke;
    }
  }

  &__reject {
    cursor: pointer;
    margin: 10px auto;

    @include media-breakpoint-up(md) {
      margin: 20px auto;
    }
  }
}
</style>
